module.exports = __webpack_public_path__ + "img/landmark-dome.633570fe.svg";